import React, { useEffect, useState } from "react";
import { useLanguage } from "../languageContext";
import translations from "../translation.json";
import ColumnChart from "./columnChart";
import AppointmentsPerHour from "./appointmentsPerHour";
const AppointmentsSection = ({
  isDarkMode,
  dashboardData,
  getDataByDate,
  eventDates,
}) => {
  const { language } = useLanguage();
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (dashboardData) {
      setSelectedDate(dashboardData?.graphDate);
    }
  }, [dashboardData]);



  return (
    <div className="py-2">
      <div className="row">
        <div className="col-6">
          <div className="d-flex flex-column flex-wrap w-100 gap-4">
            <div className="d-flex w-100 gap-4">
              <div className="d-flex w-100 gap-2">
                <div
                  className="d-flex flex-column align-items-center justify-content-center w-50"
                  style={{
                    backgroundColor: "#445574",
                    minHeight: "230px",
                    borderRadius: "0.375rem",
                  }}
                >
                  <i
                    className="bi bi-calendar"
                    style={{
                      fontSize: "40px",
                      color: "#fff",
                      // marginBottom: "16px",
                    }}
                  />

                  <p
                    style={{
                      fontSize: "48px",
                      fontWeight: "700",
                      color: "#ffffff",
                      textAlign: "center",
                    }}
                  >
                    {dashboardData?.totalAppointments}
                  </p>

                  <p
                   className=" text-white"
                  >
                    {translations.eventView.appointments[language]}
                  </p>
                </div>
                <div
                  className="d-flex flex-column align-items-center justify-content-center w-50"
                  style={{
                    backgroundColor: "#3b4f63",
                    minHeight: "230px",
                    borderRadius: "0.375rem",
                  }}
                >
                  <i
                    className="bi bi-people-fill"
                    style={{
                      fontSize: "40px",
                      color: "#fff",
                      // marginBottom: "16px",
                    }}
                  />

                  <p
                    style={{
                      fontSize: "48px",
                      fontWeight: "700",
                      color: "#ffffff",
                      textAlign: "center",
                    }}
                  >
                    {dashboardData?.walkinAppointments}
                  </p>

                  <p
                    className="text-center text-white"
                  >
                    {translations.createProspective.prospectiveSourceOptions.opt8[language]}
                  </p>
                </div>
              </div>
              <div
                className="d-flex align-items-center justify-content-center w-100"
                style={{
                  backgroundColor: "#F74513",
                  minHeight: "230px",
                  borderRadius: "0.375rem",
                }}
              >
                <span
                  className="text-white mb-0 me-2"
                  style={{ fontSize: "60px" }}
                >
                  <i className="bi bi-patch-check-fill"></i>
                </span>
                <div className="d-flex flex-column">
                  <p
                    className="d-flex align-items-center text-white gap-2"
                    style={{
                      fontSize: "70px",
                      fontWeight: "700",
                      // marginLeft: "-5px",
                    }}
                  >
                    {/* CAD {numeral (graphData?.aveAmount).format("0,000.00")} */}
                    {dashboardData?.confirmed}{" "}
                    <span style={{ fontSize: "1.475rem" }}>
                      ({dashboardData?.confirmedAppointment}%){" "}
                    </span>
                  </p>
                  <p className="text-center text-white" style={{}}>
                    {
                      translations.eventView.confirmedToDate[language]
                    }
                  </p>
                </div>
              </div>
            </div>
            <div className="d-flex w-100 gap-4">
              <div
                className="d-flex align-items-center justify-content-center w-100"
                style={{
                  backgroundColor: "#32DBB4",
                  minHeight: "230px",
                  borderRadius: "0.375rem",
                }}
              >
                <span
                  className="text-white mb-0 me-2"
                  style={{ fontSize: "60px" }}
                >
                  <i className="bi bi-person-walking"></i>
                </span>
                <div className="d-flex flex-column">
                  <p
                    className="d-flex align-items-center text-white gap-2"
                    style={{
                      fontSize: "70px",
                      fontWeight: "700",
                      // marginLeft: "-5px",
                      justifyContent:'center'
                    }}
                    
                  >
                    {/* CAD {numeral (graphData?.aveAmount).format("0,000.00")} */}
                    {dashboardData?.attended}{" "}
                    {/* <span style={{ fontSize: "1.475rem" }}>
                      ({dashboardData?.attendedAppointment}%){" "}
                    </span> */}
                  </p>
                  <p className="text-center text-white" style={{}}>
                    {translations.eventView.attended[language]}
                  </p>
                </div>
              </div>
              <div
                className="d-flex align-items-center justify-content-center w-100"
                style={{
                  backgroundColor: " #327DDA",
                  minHeight: "230px",
                  borderRadius: "0.375rem",
                }}
              >
                <span
                  className="text-white mb-0 me-2"
                  style={{ fontSize: "60px" }}
                >
                  <i className="bi bi-car-front-fill"></i>
                </span>
                <div className="d-flex flex-column">
                  <p
                    className="d-flex align-items-center text-white gap-2"
                    style={{
                      fontSize: "70px",
                      fontWeight: "700",
                      // marginLeft: "-5px",
                    }}
                  >
                    {/* CAD {numeral (graphData?.aveAmount).format("0,000.00")} */}
                    {dashboardData?.sold}{" "}
                    <span style={{ fontSize: "1.475rem" }}>
                      ({dashboardData?.soldAppointment}%){" "}
                    </span>
                  </p>
                  <p className="text-center text-white" style={{}}>
                    {translations.eventView.sold[language]}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-6">
          <div
            className="h-100 w-100"
            style={{
              // boxShadow: "0 0 40px rgba(0, 0, 0, 0.15)",
              background: isDarkMode ? "" : "rgba(243,243,243)",
              borderRadius: "0.375rem",
            }}
          >
            <div className="d-flex align-items-center p-2">
              <div className="w-50">
                <h3 className={`${isDarkMode ? "darkthead" : ""}`}>
                  {translations.eventView.totalAppointmentsPerHour[language]}
                </h3>
              </div>
              <div className="w-50">
                <div className="input-group" style={{ width: "100%" }}>
                  <span
                    className="input-group-text"
                    style={{
                      backgroundColor: isDarkMode ? "transparent" : "",
                      color: isDarkMode ? "#ffffff" : "#000000",
                      border: isDarkMode
                        ? "1px solid #495057"
                        : "1px solid #dee2e6",
                    }}
                  >
                    Date
                  </span>

                  <select
                    class={`form-select ${isDarkMode ? "custom-select" : ""}`}
                    value={selectedDate}
                    onChange={(e) => {
                      setSelectedDate(e.target.value);
                      if (e.target.value !== "") {
                        getDataByDate(
                          { graphDate: e.target.value },
                          "appointmentsPerHourGraph"
                        );
                      }
                    }}
                    style={{
                      backgroundColor: isDarkMode ? "transparent" : "",
                      color: isDarkMode ? "#ffffff" : "#000000",
                      border: isDarkMode
                        ? "1px solid #495057"
                        : "1px solid #dee2e6",
                    }}
                  >
                    <option
                      value=""
                      style={{
                        background: isDarkMode ? "#1B1F22" : "",
                        color: isDarkMode ? "#ffffff" : "",
                      }}
                    >
                      {translations.dropdown.select[language]}
                    </option>
                    {eventDates &&
                      eventDates.length > 0 &&
                      eventDates.map((date) => (
                        <option
                          key={date.value}
                          value={date.value}
                          style={{
                            background: isDarkMode ? "#1B1F22" : "",
                            color: isDarkMode ? "#ffffff" : "",
                          }}
                        >
                          {date.label}
                        </option>
                      ))}
                  </select>

                  {/* <input
                    type="date"
                    className={`form-control`}
                    // style={{
                    //   backgroundColor: isDarkMode ? "transparent" : "",
                    //   color: isDarkMode ? "#ffffff" : "#000000",
                    //   border: isDarkMode
                    //     ? "1px solid #495057"
                    //     : "1px solid #dee2e6",
                    // }}
                    // value={new Date().toISOString().split("T")[0]}
                    onChange={(e) => {
                      getDataByDate({ graphDate: e.target.value }, "appointmentsPerHourGraph");
                    }}
                  /> */}
                </div>
              </div>
            </div>
            {dashboardData && (
              <AppointmentsPerHour
                isDarkMode={isDarkMode}
                graphData={dashboardData.appointmentsPerHourGraph}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentsSection;
